import React from 'react';
import * as dateFns from 'date-fns';

import { fixDecimals } from '../../../helpers';
import { Metric } from '../types';

const metric = ({ label, current, target, flag, live } : Metric) => {
  let diff = fixDecimals(current - target, 1);
  let complement = 100 - ((Math.abs(~~diff) / current) * 100);
  if (flag) {
    diff = fixDecimals(dateFns.differenceInMinutes(dateFns.parse('2014-02-11T' + current, 'yyyy-MM-dd', new Date()),
      dateFns.parse('2014-02-11T' + target, 'yyyy-MM-dd', new Date())), 1);
  }
  complement = target;
  complement = Math.max(0, complement);
  complement = Math.min(100, complement);
  return (
    <div className="g-b" style={{marginBottom: '20px'}}>
      <div className="g-l">
        {label}
      </div>
      <div className="g-r">
        {flag ? current : fixDecimals(current, 1)}
      </div>
      {!live?
        <>
          <div className='bar-color' style={{backgroundColor: '#AABDCB' } }/>
          <div className='bar-blue' style={{ width: `${complement}%` }} />
          <span className='number-02' style={{color: '#42859E', fontWeight: 'bold' }}>
          {!isNaN(target) ? String(target) + '%' : target}
      </span></>:
        <label className='livebar'/>
      }
    </div>
  );
};

export default metric;
